<template>
  <span>{{
    item[slotData.name] &&
      $number(item[slotData.name], slotData.number_format || "")
  }}</span>
</template>

<script>
export default {
  name: "NumberItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  }
};
</script>

<style scoped></style>
